/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { TicketComment } from "./TicketComment";
import {
    TicketCommentFromJSON,
    TicketCommentFromJSONTyped,
    TicketCommentToJSON,
} from "./TicketComment";
import type { UserInfo } from "./UserInfo";
import {
    UserInfoFromJSON,
    UserInfoFromJSONTyped,
    UserInfoToJSON,
} from "./UserInfo";

/**
 *
 * @export
 * @interface TicketSummary
 */
export interface TicketSummary {
    /**
     *
     * @type {string}
     * @memberof TicketSummary
     */
    ticketId?: string;
    /**
     *
     * @type {string}
     * @memberof TicketSummary
     */
    url?: string;
    /**
     *
     * @type {string}
     * @memberof TicketSummary
     */
    title?: string;
    /**
     *
     * @type {string}
     * @memberof TicketSummary
     */
    organisationId?: string;
    /**
     *
     * @type {string}
     * @memberof TicketSummary
     */
    serviceModelTag?: string;
    /**
     *
     * @type {string}
     * @memberof TicketSummary
     */
    scheduledMaintenanceTag?: string;
    /**
     *
     * @type {string}
     * @memberof TicketSummary
     */
    siteTag?: string;
    /**
     *
     * @type {string}
     * @memberof TicketSummary
     */
    deviceIdentity?: string;
    /**
     *
     * @type {string}
     * @memberof TicketSummary
     */
    description?: string;
    /**
     *
     * @type {UserInfo}
     * @memberof TicketSummary
     */
    author?: UserInfo;
    /**
     *
     * @type {string}
     * @memberof TicketSummary
     */
    status?: TicketSummaryStatusEnum;
    /**
     *
     * @type {string}
     * @memberof TicketSummary
     */
    statusText?: string;
    /**
     *
     * @type {Date}
     * @memberof TicketSummary
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof TicketSummary
     */
    updatedAt?: Date;
    /**
     *
     * @type {{ [key: string]: string; }}
     * @memberof TicketSummary
     */
    extraMetadata?: { [key: string]: string };
    /**
     *
     * @type {Array<TicketComment>}
     * @memberof TicketSummary
     */
    comments?: Array<TicketComment>;
}

/**
 * @export
 */
export const TicketSummaryStatusEnum = {
    Unknown: "Unknown",
    Open: "Open",
    InProgress: "InProgress",
    Escalated: "Escalated",
    Resolved: "Resolved",
} as const;
export type TicketSummaryStatusEnum =
    (typeof TicketSummaryStatusEnum)[keyof typeof TicketSummaryStatusEnum];

/**
 * Check if a given object implements the TicketSummary interface.
 */
export function instanceOfTicketSummary(value: object): value is TicketSummary {
    return true;
}

export function TicketSummaryFromJSON(json: any): TicketSummary {
    return TicketSummaryFromJSONTyped(json, false);
}

export function TicketSummaryFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): TicketSummary {
    if (json == null) {
        return json;
    }
    return {
        ticketId: json["ticketId"] == null ? undefined : json["ticketId"],
        url: json["url"] == null ? undefined : json["url"],
        title: json["title"] == null ? undefined : json["title"],
        organisationId:
            json["organisationId"] == null ? undefined : json["organisationId"],
        serviceModelTag:
            json["serviceModelTag"] == null
                ? undefined
                : json["serviceModelTag"],
        scheduledMaintenanceTag:
            json["scheduledMaintenanceTag"] == null
                ? undefined
                : json["scheduledMaintenanceTag"],
        siteTag: json["siteTag"] == null ? undefined : json["siteTag"],
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        description:
            json["description"] == null ? undefined : json["description"],
        author:
            json["author"] == null
                ? undefined
                : UserInfoFromJSON(json["author"]),
        status: json["status"] == null ? undefined : json["status"],
        statusText: json["statusText"] == null ? undefined : json["statusText"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
        extraMetadata:
            json["extraMetadata"] == null ? undefined : json["extraMetadata"],
        comments:
            json["comments"] == null
                ? undefined
                : (json["comments"] as Array<any>).map(TicketCommentFromJSON),
    };
}

export function TicketSummaryToJSON(value?: TicketSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        ticketId: value["ticketId"],
        url: value["url"],
        title: value["title"],
        organisationId: value["organisationId"],
        serviceModelTag: value["serviceModelTag"],
        scheduledMaintenanceTag: value["scheduledMaintenanceTag"],
        siteTag: value["siteTag"],
        deviceIdentity: value["deviceIdentity"],
        description: value["description"],
        author: UserInfoToJSON(value["author"]),
        status: value["status"],
        statusText: value["statusText"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
        extraMetadata: value["extraMetadata"],
        comments:
            value["comments"] == null
                ? undefined
                : (value["comments"] as Array<any>).map(TicketCommentToJSON),
    };
}
